/**
 * Status específicos para o fluxo de Extensão de Uso
 * Os valores são os nomes do enum no backend (StatusExtensaoUso)
 */
export const STATUS_EXTENSAO_USO = {
    /** Registro aprovado pelo MAPA, mas extensão de uso ainda não iniciada */
    NaoIniciado: "NaoIniciado",
    
    /** Requisitante preencheu regiões, aguardando técnico preencher dados REC */
    AguardandoResponsavel: "AguardandoResponsavel",
    
    /** Responsável preencheu dados REC, aguardando regulatório aprovar */
    AguardandoRegulatorio: "AguardandoRegulatorio",
    
    /** Regulatório reprovou a solicitação */
    ReprovadoPeloRegulatorio: "ReprovadoPeloRegulatorio",
    
    /** Regulatório aprovou e enviou ao MAPA */
    AguardandoMAPA: "AguardandoMAPA",
    
    /** MAPA aprovou (protocolo preenchido) */
    AprovadoPeloMAPA: "AprovadoPeloMAPA",
    
    /** MAPA reprovou */
    ReprovadoPeloMAPA: "ReprovadoPeloMAPA",
    
    /** Solicitação cancelada */
    Cancelado: "Cancelado",
} as const;

/**
 * Descrições amigáveis para exibição no frontend
 */
export const STATUS_EXTENSAO_USO_DESCRICAO: Record<string, string> = {
    NaoIniciado: "Não Iniciado",
    AguardandoResponsavel: "Aguardando Técnico",
    AguardandoRegulatorio: "Em Análise pelo Regulatório",
    ReprovadoPeloRegulatorio: "Reprovado Pelo Regulatório",
    AguardandoMAPA: "Aguardando Aprovação MAPA",
    AprovadoPeloMAPA: "Aprovado Pelo MAPA",
    ReprovadoPeloMAPA: "Reprovado Pelo MAPA",
    Cancelado: "Cancelado",
};

export type StatusExtensaoUsoType = typeof STATUS_EXTENSAO_USO[keyof typeof STATUS_EXTENSAO_USO];
